
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/developer",
      function () {
        return require("private-next-pages/en/developer/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/developer"])
      });
    }
  